import { Link } from 'react-router-dom';
import { blogArticles } from '@/mocks/blogArticles';

export default function SEOContentHub() {
  const articles = blogArticles;

  return (
    <section id="blog" className="py-16 md:py-24 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 mb-16">
          <div className="lg:col-span-1">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-extralight text-foreground-950 leading-[1.05] tracking-tight">
              Smart Shopping Intelligence
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mt-4 leading-relaxed">
              Data-driven insights and comprehensive pandabuy spreadsheet guides to help you make informed shopping decisions with confidence.
            </p>
          </div>

          <div className="lg:col-span-2 grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-extrabold text-accent-600">10K+</p>
              <p className="text-xs md:text-sm text-foreground-500 mt-1">Products<br />Compared</p>
            </div>
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-extrabold text-accent-600">Daily</p>
              <p className="text-xs md:text-sm text-foreground-500 mt-1">Spreadsheet<br />Updates</p>
            </div>
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-extrabold text-accent-600">50+</p>
              <p className="text-xs md:text-sm text-foreground-500 mt-1">Active<br />Categories</p>
            </div>
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-extrabold text-accent-600">Global</p>
              <p className="text-xs md:text-sm text-foreground-500 mt-1">Shipping<br />Insight</p>
            </div>
          </div>
        </div>

        <h3 className="text-xl md:text-2xl font-semibold text-foreground-950 mb-8">
          Pandabuy Spreadsheet Guides &amp; Articles
        </h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.slice(0, 9).map((article) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.01] cursor-pointer flex flex-col"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h4 className="text-foreground-950 font-semibold text-base mb-2 leading-snug">
                  {article.title}
                </h4>
                <p className="text-foreground-500 text-xs leading-relaxed mb-4 flex-1">
                  {article.desc}
                </p>
                <div className="flex items-center justify-between">
                  <span className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-foreground-950 text-white text-xs font-semibold whitespace-nowrap">
                    Read Guide
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                  <p className="text-xs text-foreground-400">
                    {article.readTime}
                  </p>
                </div>
                <p className="text-xs text-foreground-400 mt-2">{article.date}</p>
              </div>
            </Link>
          ))}
        </div>

        {articles.length > 9 && (
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.slice(9).map((article) => (
              <Link
                key={article.slug}
                to={`/blog/${article.slug}`}
                className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.01] cursor-pointer flex flex-col"
              >
                <div className="w-full h-48 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <h4 className="text-foreground-950 font-semibold text-base mb-2 leading-snug">
                    {article.title}
                  </h4>
                  <p className="text-foreground-500 text-xs leading-relaxed mb-4 flex-1">
                    {article.desc}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-foreground-950 text-white text-xs font-semibold whitespace-nowrap">
                      Read Guide
                      <i className="ri-arrow-right-line text-xs"></i>
                    </span>
                    <p className="text-xs text-foreground-400">
                      {article.readTime}
                    </p>
                  </div>
                  <p className="text-xs text-foreground-400 mt-2">{article.date}</p>
                </div>
              </Link>
            ))}
          </div>
        )}

        <div className="mt-10 text-center">
          <p className="text-foreground-500 text-sm mb-4">
            Search popular pandabuy spreadsheet categories:
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {[
              'pandabuy spreadsheet sneakers',
              'pandabuy spreadsheet tech',
              'pandabuy spreadsheet streetwear',
              'best pandabuy spreadsheet 2026',
              'pandabuy sheet comparison',
              'product sourcing spreadsheet',
            ].map((kw) => (
              <span
                key={kw}
                className="px-4 py-2 rounded-full bg-background-50 text-foreground-600 text-xs font-medium border border-background-200"
              >
                {kw}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}